import Skeleton from '@cobliteam/colib-ui/Skeleton';
import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import { Suspense } from 'react';
import MultiSelectVehicleGroupsSidebar from '../../MultiSelects/MultiSelectVehicleGroupsSidebar';

const FilterGroupComponent = () => {
  const { sidebar } = useDashboard();
  const shouldShowFilterGroup = Boolean(sidebar.route?.header?.filterGroup);

  if (!shouldShowFilterGroup) return null;

  return (
    <Suspense fallback={<Skeleton className='h-8 w-40 shrink-0' />}>
      <MultiSelectVehicleGroupsSidebar />
    </Suspense>
  );
};

export default FilterGroupComponent;
